import { styled } from "styled-components"
import { theme } from "../../../styles/Theme"

const Contacts = styled.section`
    position: relative;

`

const Form = styled.form`
max-width: 540px;
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
gap: 16px;
margin: 0 auto;

textarea {/* наша textarea находится в Field as"textarea", чтобы к ней обратиться, делаем это через StyledForm по тегу textarea. */
    resize: none;
    height: 155px;
}
`

const Field = styled.input`
width: 100%;
background-color: ${theme.colors.secondaryBg};
border: 1px solid ${theme.colors.borderColor};
padding: 7px 15px;
font-family: "Poppins", sans-serif;/* здесь мы оставили шрифт(а он у нас в переменной записан) браузер перечеркивает и даёт font-family пустой, пожтому мы указываем шрифт. */
font-weight: 400;
font-size: 12px;
letter-spacing: 0.05em;
color: ${theme.colors.font};

/* placeholder-?какойто псевдоэлемент? поэтому пишем&.... */
&::placeholder {
    color: ${theme.colors.placeholderColor};
    text-transform: capitalize;
}

&:focus-visible {
outline: 1px solid ${theme.colors.borderColor};/* outline браузер делает по умолчанию, но нам нужно менять цвет так как убирать низя(лучше такого не делать) */
}

`
export const S = {
    Contacts,
    Form,
    Field
}